module.exports = __webpack_public_path__ + "img/multiclass-ezgif.2ad746d3.gif";